import Vue from "vue"
import Router from "vue-router"
import HomePage from "@/components/HomePage"
import FeaturesPage from "@/components/FeaturesPage"
import SupportPage from "@/components/SupportPage"
import DownloadPage from "@/components/DownloadPage"
import FaqPage from "@/components/FaqPage"
import RoadmapPage from "@/components/RoadmapPage"
import TutorialPage from "@/components/TutorialPage"

Vue.use(Router)

export default new Router({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      name: "home-page",
      component: HomePage
    },
    {
      path: "/features",
      name: "features-page",
      component: FeaturesPage
    },
    {
      path: "/download",
      name: "download-page",
      component: DownloadPage
    },
    {
      path: "/faq",
      name: "faq-page",
      component: FaqPage
    },
    {
      path: "/roadmap",
      name: "roadmap-page",
      component: RoadmapPage
    },
    {
      path: "/support",
      name: "support-page",
      component: SupportPage
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js